import React from "react";
import VMsTableHeadColumnControls from "./VMsTableComponents/VMsTableHeadColumnControls";

const VMsTableHead = () => {
  return (
    <div data-testid="VMsTableHeadColumnControls">
      <VMsTableHeadColumnControls />
    </div>
  );
};

export default VMsTableHead;
